import { AssetResourceCategoryMenuItem } from '../../../../types';

export function groupSubitemsByCloud(subitems: AssetResourceCategoryMenuItem['subitems'] = []) {
  const grouped: { [key: string]: typeof subitems } = {};

  for (const item of subitems) {
    const { cloud } = item;
    if (!grouped[cloud]) {
      grouped[cloud] = [];
    }
    grouped[cloud].push(item);
  }

  return Object.entries(grouped).sort((a, b) => a[0].localeCompare(b[0]));
}
